module.exports = {
  lang: {
    t1: `Home`,
    t2: `Business Card`,
    t3: `Follow`,
    t4: `Contacts`,
    t5: `Messages`,
    t6: `Login`,
    t7: `Register`,
    t8: `Global Business Connectivity New Platform, New Territory for Enterprise Digital Marketing`,
    t9: ` Login with Mobile Number`,
    t10: `Mobile Number`,
    t11: `Verification Code`,
    t12: `Please enter your mobile number`,
    t13: `Please enter the verification code`,
    t14: `Get`,
    t15: `Login`,
    t16: `Please enter the correct format of mobile number`,
    t17: `Verification Code Sent`,
    t18: `Incorrect Verification Code Entered. Please Verify and Re-enter`,
    t19: `Login Successful`,
    t20: `Your Verification Code is (0). Please use it within {1} minute(s).`,
    t21: `Cancel`,
    t22: `Confirm`,
    t23: `Warm Tips`,
    t24: `Your WeMeet account registration is not yet complete. Act now to finish the sign-up process and enjoy diverse interactions and endless possibilities.`,
    t25: `Go to Sign Up`,
    t26: `WeMeet Email Login`,
    t27: `Account Name`,
    t28: `Enter your email`,
    t29: `Password`,
    t30: `Enter your password`,
    t31: `Forgot password?`,
    t32: `Log in`,
    t33: `Other login methods`,
    t34: `Already registered for the WeMeet Mini Program? Use it now.`,
    t35: `Login with Phone Number`,
    t36: `Please enter your email first.`,
    t37: `Please enter your password first.`,
    t38: `The email address format is incorrect`,
    t39: `If you already have a WeMeet account, you can log in directly`,
    t40: `Log in`,
    t41: `Profile picture`,
    t42: `Please upload a real profile picture`,
    t43: `Full name`,
    t44: `First name`,
    t45: `Last Name`,
    t46: `Organization name`,
    t47: `Please enter the name of your organization`,
    t48: `Position`,
    t49: `Please enter the title of your position within the organization`,
    t50: `Email`,
    t51: `Enter your email`,
    t52: `Mobile Number`,
    t53: `Please enter your mobile number`,
    t54: `Region`,
    t55: `Please select a region`,
    t56: `Zone`,
    t57: `Please select province, city, district`,
    t58: `Address`,
    t59: `Please enter your address`,
    t60: `I have read and agree to WeMeet's`,
    t61: `Terms of Service`,
    t62: `Privacy Policy`,
    t63: `Continue`,
    t64: `Please check the User Agreement first`,
    t65: `Please enter your name`,
    t66: `Please fill in your last name`,
    t67: `Please fill in your email first`,
    t68: `Please fill in your organization's name first`,
    t69: `The email address format is incorrect`,
    t70: `Cancel`,
    t71: `Complete`,
    t72: `Verify Mobile Number`,
    t73: `Mobile Number`,
    t74: `Verification Code`,
    t75: `Please enter the verification code`,
    t76: `Get`,
    t77: `Skip Verification`,
    t78: `Submit`,
    t79: `Verified`,
    t80: `Incorrect Verification Code Entered. Please Verify and Re-enter`,
    t81: `Skipped`,
    t82: `Warm Tips`,
    t83: `The phone number you entered is already registered with a WeMeet account. No need to register again; please log in now.`,
    t84: `Go to login`,
    t85: `Warm Tips`,
    t86: `The email address you entered is already registered with a WeMeet account. No need to register again; please log in now.`,
    t87: `Go to login`,
    t88: `A verification link has been sent.`,
    t89: `Please check your email and click the link to complete registration.`,
    t90: `Got it`,
    t91: `Welcome to WeMeet`,
    t92: `Welcome to WeMeet! Please click the button to complete your registration. Friendly reminder: This link is valid for 24 hours, please act promptly.`,
    t93: `Sign up`,
    t94: `Your email has been activated. Please enter your password.`,
    t95: `Enter password`,
    t96: `Enter your password`,
    t97: `Confirm password`,
    t98: `Please re-enter your password`,
    t99: `Must contain a combination of uppercase and lowercase letters, numbers, and special characters, with a length between 8 and 20 characters`,
    t100: `Enter your password`,
    t101: `Please re-enter your password`,
    t102: `Passwords do not match`,
    t103: `Congratulations on completing your registration`,
    t104: `You have been logged in to WeMeet. You may now continue with your previous actions.`,
    t105: `Continue Your Experience`,
    t106: `Warm Tips`,
    t107: `The link has expired. Please click the button to retrieve it again.`,
    t108: `Resend`,
    t109: `Terms of Service`,
    t110: `Privacy Policy`,
    t111: `Retrieve password`,
    t112: `Please enter the account for which you wish to retrieve the password`,
    t113: `Account Name`,
    t114: `Enter your email`,
    t115: `Submit`,
    t116: `Please enter your email first.`,
    t117: `The email address format is incorrect`,
    t118: `Email sent`,
    t119: `Please check your email, click the link, and reset your password.`,
    t120: `Got it`,
    t121: `Reset Password - WeMeet`,
    t122: `Your password reset request has been confirmed, and the system has generated a temporary password reset link. Friendly reminder: This link is valid for 24 hours, please act promptly.`,
    t123: `Reset Password`,
    t124: `Password Reset Successful`,
    t125: `You have been logged in to WeMeet. Welcome back.`,
    t126: `Go to Home`,
    t127: `Contacts`,
    t128: `New contact request`,
    t129: `Agree`,
    t130: `Ignore`,
    t131: `Approved`,
    t132: `Ignored`,
    t133: `Following`,
    t134: `Followed`,
    t135: `Messages`,
    t136: `Unprocessed request`,
    t137: `Please enter your name or phone number`,
    t138: `No matching content found`,
    t139: `There are no more available`,
    t140: `Contact request`,
    t141: `Agree`,
    t142: `Ignore`,
    t143: `Approved`,
    t144: `Ignored`,
    t145: `WeMeet AI Space`,
    t146: `Following`,
    t147: `Unfollowed`,
    t148: `vCard`,
    t149: `Connect`,
    t150: `Chat now`,
    t151: `Pending approval`,
    t152: `Remove contact`,
    t153: `Personal introduction`,
    t154: `Personal profile`,
    t155: `Warm Tips`,
    t156: `Your contact request has been submitted, and upon approval, you will automatically be following TA. Alternatively, you can choose to follow TA now to learn more about them.`,
    t157: `Don't follow for now`,
    t158: `Follow`,
    t159: `Following`,
    t160: `Remove Contact Relationship`,
    t161: `After removing the contact relationship, the other party will no longer be able to view your personal information, but they will not simultaneously unfollow you.`,
    t162: `Think Again`,
    t163: `Remove contact`,
    t164: `Operation Successful`,
    t165: `WeMeet AI Assistant`,
    t166: `Please Enter Your Question`,
    t167: `Send`,
    t168: `Note that AI interaction content may be inaccurate and does not represent the platform's viewpoint.`,
    t169: `WeMeet Business Card`,
    t170: `Download`,
    t171: `Edit Business Card`,
    t172: `Download QR Code`,
    t173: `The image has been generated. Please save it. Scan the QR code to save the contact.`,
    t174: `Profile picture`,
    t175: `Please upload a real profile picture`,
    t176: `Full name`,
    t177: `First name`,
    t178: `Last name`,
    t179: `Please Enter Your Name`,
    t180: `Organization name`,
    t181: `Please enter the name of your organization`,
    t182: `Position`,
    t183: `Please enter the title of your position within the organization`,
    t184: `Email`,
    t185: `Enter your email`,
    t186: `Mobile Number`,
    t187: `Please enter your mobile number`,
    t188: `Region`,
    t189: `Please select a region`,
    t190: `Zone`,
    t191: `Please select province, city, district`,
    t192: `Address`,
    t193: `Please enter your address`,
    t194: `Please enter your name`,
    t195: `Please fill in your last name`,
    t196: `Please fill in your email first`,
    t197: `Please fill in your organization's name first`,
    t198: `The email address format is incorrect`,
    t199: `Chat Room`,
    t200: `Photo`,
    t201: `Take a Picture`,
    t202: `Please Enter Your Message`,
    t203: `Send`,
    t204: `Read`,
    t205: `Unread`,
    t206: `Recall Time Limit Expired`,
    t207: `Cancel`,
    t208: `Photo`,
    t209: `Album`,
    t210: `Shoot`,
    t211: `Select from Album`,
    t212: `Cancel`,
    t213: `Photo`,
    t214: `Portrait`,
    t215: `Preview`,
    t216: `Complete`,
    t217: `WeMeet AI Space`,
    t218: `Contact Us`,
    t219: `Contact Me`,
    t220: `Full name`,
    t221: `Organization`,
    t222: `Position`,
    t223: `Phone`,
    t224: `Email`,
    t225: `Region`,
    t226: `Zone`,
    t227: `Address`,
    t228: `Please Enter Your Name`,
    t229: `Please fill in your organization's name`,
    t230: `Please fill in your position`,
    t231: `Please enter your phone number`,
    t232: `Please fill in your email address`,
    t233: `Please select a region`,
    t234: `Please select province, city, district`,
    t235: `Please enter an address`,
    t236: `Intention`,
    t237: `Purchase products`,
    t238: `Agent products`,
    t239: `Market cooperation`,
    t240: `Other`,
    t241: `Please Enter Your Name`,
    t242: `Please fill in your organization's name`,
    t243: `Please fill in your email address`,
    t244: `The email address format is incorrect`,
    t245: `Message submitted`,
    t246: `Leave a message`,
    t247: `Please enter the content of your inquiry`,
    t248: `Confirm`,
    t249: `Please log in or sign up first`,
    t250: `Followers`,
    t251: `Contact Us`,
    t252: `Products`,
    t253: `Team`,
    t254: `Overview`,
    t255: `Album`,
    t256: `Qualification`,
    t257: `Registered Capital`,
    t258: `Founding Date`,
    t259: `Registered Address`,
    t260: `Upstream`,
    t261: `Midstream`,
    t262: `Downstream`,
    t263: `Industries associées`,
    t264: `Process`,
    t265: `Save`,
    t266: `Verified`,
    t267: `Chinese`,
    t268: `English`,
    t269: `French`,
    t270: `Russian`,
    t271: `Spanish`,
    t272: `Japanese`,
    t273: `Korean`,
    t274: `Indonesian`,
    t275: `Vietnamese`,
    t276: `German`,
    t277: `Turkish`,
    t278: `Italian`,
    t279: `Portuguese`,
    t280: `Thai`,
    t281: `Malay`,
    t282: `Arabic`,
    t283: `Incorrect username or password`,
    t284: `Please read and accept the WeMeet User Agreement first`,
    t285: `No relevant content available`,
    t286: `Type`,
    t287: `Attribute`,
    t288: `Details`,
    t289: `Other`,
    t290: `Total of 2 products`,
    t291: `{1} invites you to visit the WeMeet AI Space of {2}`,
    t292: `Click here for an example or enter a question:`,
    t293: `Refresh`,
    t294: `You can also click on the business card below to add contacts for more information:`,
    t295: `Learn`,
    t296: `WeMeet Digital Meetings`,
    t297: `WeMeet Digital Exhibitions`,
    t298: `WeMeet Personal Card/WeMeet Space`,
    t299: `How to Become a WeMeet Organization Member`,
    t300: `WeMeet Digital Conference Service provides you with a comprehensive online meeting solution, including but not limited to meeting creation and publication, participant registration management, electronic check-in, meeting scheduling, meeting material sharing, real-time interactive discussions, and guest interactions.`,
    t301: `WeMeet Digital Exhibition, helping to quickly build an exhibition micro-official website. Display exhibitor information, exhibit introductions, live exhibition broadcasts, exhibition registration, event schedules, and more, allowing participating companies and audiences to easily understand exhibition details. To use the WeMeet Digital Exhibition feature, please complete the institutional entry process first. Click on "My", scroll down to "Service Center" - "Institutional Entry" and follow the prompts to complete the entry process.`,
    t302: `WeMeet personal users only need to authorize their WeChat ID, phone number, and complete platform registration to obtain a personal digital business card and maintain their personal AI Lounge (including personal resume, updates, photos, documents, etc.).`,
    t303: `Click on the "My" option on the bottom menu bar of the mini-program to update the personal business card page and improve the personal homepage.`,
    t304: `Combination of uppercase and lowercase letters, numbers, and punctuation marks, with a length between 8-20 characters.`,
    t305: `Enter product name`,
    t306: `No more items`,
    t307: `Click on the top right corner`,
    t308: `Choose your preferred way to share`,
    t309: `Got it`,
    t310: `Please complete registration and login first`,
    t311: `Learn more`,
    t312: `Related Products`,
    t313: `Thank you for visiting`,
    t314: `Log Out`,
    t315: `Followed organization`,
    t316: `Previous`,
    t317: `Next`,
    t318: `None`,
    t319: `{1} invites you to visit {2}`,
    t320: `AI Lounge has not maintained the current language`,
    t321: `AI Lounge has switched to the current language`,
    t322: `The link has been activated`,
    t323: `The network is busy, please try again later`,
    t324: `Product details have been switched to the current language`,
    t325: `Product details are not currently maintained in this language`,
    t326: `Hello, I am WeMeet intelligent AI assistant, ready to provide you with thoughtful service at any time! How can I help you?`,
    t327: `Enter Name`,
    t328: `I have found the relevant contact information, please check the contact card below.`,
    t329: `Attachment`,
    t330: `I have not found the relevant contact information.`,
    t331: `I have forwarded your inquiry to the colleague responsible below; you can also click on the business card to contact immediately.`,
    t332: `Exhibition`,
    t333: `Please enter`,
    t334: `User`,
    t335: `No more items`,
    t336: `Refresh successful`,
    t337: `Loading`,
    t338: `Release to Refresh`,
    t339: `The verification code has expired`,
    t340: `Loading`,
    t341: `Message Translation`,
    t342: `Enable message translation?`,
    t343: `When enabled, automatically translate text messages sent by the other party into the selected language and display them below the original message.`,
    t344: `Not exceeding 500 characters`,
    t345: `Uploading`,
    t346: `File`,
    t347: `The current uploaded file type does not meet the requirements`,
    t348: `Disable message translation?`,
    t349: `After turning off, it will no longer translate the text messages sent by the other party.`,
    t350: `Confirm`,
    t351: `Copied`,
    t352: `The network signal is weak, the webpage loading may be affected. Please try refreshing the page or try again later.`,
    t353: `Refresh Page`,
    t354: `Send Failed`,
    t355: `Select Language`,
    t356: `Product`,
    t357: `Exhibition`,
    t358: `Venue`,
    t359: `Job`,
    t360: `Please enter a keyword`,
    t361: `List`,
    t362: `Gender`,
    t363: ``,
    t364: ``,
    t365: `Region`,
    t366: `Mobile Number`,
    t367: `Company/Organization`,
    t368: `Position`,
    t369: `Email`,
    t370: `Department`,
    t371: `Single Choice`,
    t372: `Multiple Choice`,
    t373: `Name`,
    t374: `Gender`,
    t375: `Please select a region`,
    t376: `Please enter`,
    t377: `Add picture`,
    t378: `Click to upload file`,
    t379: `Document type`,
    t380: `Please enter document number`,
    t381: `Resident Identity Card of the People's Republic of China`,
    t382: `Resident Identity Card of the People's Republic of China`,
    t383: `Mainland Travel Permit for Hong Kong and Macao Residents`,
    t384: `Mainland Travel Permit for Hong Kong and Macao Residents`,
    t385: `Mainland Travel Permit for Taiwan Residents`,
    t386: `Mainland Travel Permit for Taiwan Residents`,
    t387: `Residence permit for Taiwan residents of People's Republic of China`,
    t388: `Residence permit for Taiwan residents of People's Republic of China`,
    t389: `Passport`,
    t390: `Registration successful`,
    t391: `Cancel registration`,
    t392: `Your registration has been approved. Please show your entry code at the entrance.`,
    t393: `View my registration information`,
    t394: `Show my entry code`,
    t395: `You have registered. We will complete the review as soon as possible. The result will be notified to you via SMS.`,
    t396: `Review not approved`,
    t397: `Sorry, your document application was not approved.`,
    t398: `View the reason and refill the form!`,
    t399: `Reason for failure`,
    t400: `Confirm`,
    t401: `Registration under review`,
    t402: `Registration successful`,
    t403: `Review not approved`,
    t404: `Return to homepage`,
    t405: `Document type`,
    t406: `Document number`,
    t407: `Document photo`,
    t408: `Please select province, city, district`,
    t409: `Select document type`,
    t410: `Start`,
    t411: `End`,
    t412: `and fill out the form again!`,
    t413: `Check the reasons`,
    t414: `Reapply`,
    t415: `Cancel successful!`,
    t416: `Please enter the correct email`,
    t417: `Document number length cannot be less than 6 digits`,
    t418: `Registration information updated`,
    t419: `Please complete question`,
    t420: `Please check the user agreement`,
    t421: `Registration portal not yet open`,
    t421: `Verification code expired`,
    t422: `Checked in`,
    t423: `Not checked in`,
    t424: `Real-name authentication failed`,
    t425: `Real-name authentication failed, please enter the correct name`,
    t426: `Real-name authentication failed, please upload document photo`,
    t427: `Registration settings for this identity not configured`,
    t428: `Please register for the ongoing conference`,
    t429: `Registration limited to exhibition audience`,
    t430: `Registration portal not yet open`,
    t431: `You are already an exhibition guest, no need to register`,
    t432: `Identity type not configured`,
    t433: `Please upload document photo`,
    t434: `Update`,
    t435: `Please enter the invitation code`,
    t436: `This invitation code does not exist or cannot be used`,
    t437: `Please fill in the invitation code`,
    t438: `Registration channel not open`,
    t869: `Hall A+B`,
    t870: `Hall C`,
    t871: `Function hall`,
    t872: `Room 9+10`,
    t873: `Room 2+3`,
    t874: `Room 12`,
    t875: `Room 11`,
    t876: `Room 1`,
    t877: `Room 5`,
    t878: `Room 6`,
    t879: `Room 8`,
    t880: `Publishing <br/>Space`,
    t881: `Space A`,
    t882: `Space B`,
    t883: `Space C`,
    t884: `Space D`,
    t885: `Space E`,
    t886: `Space F`,
    t887: `Venue Map`,
    t888: `Floor Plan of the 2nd Floor Conference Room at Puru Hotel`,
    t889: `Floor Plan of the 3rd Floor Interactive Space at Greenland Trade Port`,
    t890: `View 3D map`,
    t891: `Please read and agree to the user agreement first.`,
    t892: `I have read and agreed to CIIE Shanghai Events and Conferences`,
    t893: `Sorry, the registration quota is full.`,
    t943: `Sorry, you have already registered for another meeting during this time slot, and you cannot register for this meeting.`,

    t547: `Notice`,
    t954: `You have already submitted the form. Would you like to register for this meeting with one click?`,
    t955: `Register`,
  },
};
